export const extra = {
  it: {
    faq: {
      overline: "FAQ",
      h2: "Domande frequenti.",
      items: [
        { q: "Quali temperature e potenze raggiunge Diamond Sky?", a: "Nella configurazione certificata ENEA il modulo Diamond SKY 50 opera fino a 130 °C e 8 bar, con potenza termica di picco di 35,5 kWt e producibilità annua certificata di 1.182 kWh/m²." },
        { q: "Come si integra con il nostro impianto esistente?", a: "Il fluido vettore ad alta temperatura alimenta gli scambiatori già presenti nel ciclo produttivo, senza modifiche invasive. L'accumulo termico stabilizza la fornitura oltre le ore di irraggiamento." },
        { q: "Qual è il ritorno economico atteso?", a: "Il payback indicativo è di 3–6 anni in funzione di irraggiamento, carico termico e prezzo del gas. La simulazione energetica sui dati reali del sito fornisce ROI e LCOE puntuali." },
        { q: "La tecnologia è compatibile con Transizione 5.0?", a: "Sì: Diamond Sky rientra nei percorsi di efficientamento energetico e autoproduzione da fonti rinnovabili agevolabili, oltre che nei bandi per la transizione ecologica." },
        { q: "Quanto spazio richiede un modulo?", a: "Il modulo Diamond SKY 50 ha un ingombro di circa 6,3 × 9 m (49,9 m² di superficie lorda) e può essere installato a terra o su coperture piane adeguate." },
      ],
    },
    cookie: {
      text: "Utilizziamo cookie tecnici e analitici per migliorare l'esperienza di navigazione. Puoi accettare o rifiutare i cookie analitici.",
      accept: "Accetta",
      reject: "Rifiuta",
    },
    notFound: { title: "Pagina non trovata", text: "Il contenuto che cerchi non esiste o è stato spostato.", back: "Torna alla home" },
  },
  en: {
    faq: {
      overline: "FAQ",
      h2: "Frequently asked questions.",
      items: [
        { q: "What temperatures and power does Diamond Sky reach?", a: "In the ENEA-certified configuration the Diamond SKY 50 module operates up to 130 °C and 8 bar, with 35.5 kWt peak thermal power and a certified annual yield of 1,182 kWh/m²." },
        { q: "How does it integrate with our existing plant?", a: "The high-temperature heat-transfer fluid feeds the heat exchangers already in your production cycle, with no invasive retrofit. Thermal storage stabilizes supply beyond daylight hours." },
        { q: "What financial return should we expect?", a: "Indicative payback is 3–6 years depending on irradiation, thermal load and gas price. The energy simulation based on your site's real data provides precise ROI and LCOE." },
        { q: "Is the technology eligible for Transition 5.0?", a: "Yes: Diamond Sky fits the incentivized energy-efficiency and renewable self-generation pathways, as well as ecological-transition funding calls." },
        { q: "How much space does one module need?", a: "The Diamond SKY 50 module has a footprint of about 6.3 × 9 m (49.9 m² gross area) and can be ground-mounted or installed on suitable flat rooftops." },
      ],
    },
    cookie: {
      text: "We use technical and analytics cookies to improve your browsing experience. You can accept or reject analytics cookies.",
      accept: "Accept",
      reject: "Reject",
    },
    notFound: { title: "Page not found", text: "The content you are looking for does not exist or has been moved.", back: "Back to home" },
  },
};
